import { AlertTriangle, Check, CheckCircle2, Clock3, Fuel, Gauge, Workflow } from "lucide-react";
import { useState } from "react";
import type { FleetAlert, Vehicle } from "../types";

export function AlertRail({
  alerts,
  vehicles,
  onSelect,
  onAcknowledge,
  canAcknowledge,
}: {
  alerts: FleetAlert[];
  vehicles: Vehicle[];
  onSelect: (vehicle: Vehicle) => void;
  onAcknowledge: (alertId: number) => Promise<void>;
  canAcknowledge: boolean;
}) {
  const [pendingId, setPendingId] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function acknowledge(alertId: number) {
    setPendingId(alertId);
    setError(null);
    try {
      await onAcknowledge(alertId);
    } catch {
      setError("No fue posible reconocer el evento");
    } finally {
      setPendingId(null);
    }
  }

  return (
    <section className="alert-rail">
      <header className="section-header">
        <div>
          <span className="eyebrow">EVENTOS CORRELACIONADOS</span>
          <h2>Atención operativa</h2>
        </div>
        <b className="alert-count">{alerts.length}</b>
      </header>
      <div className="alert-list">
        {alerts.map((alert) => {
          const vehicle = vehicles.find((item) => item.id === alert.vehicle_id);
          const isCorrelated = alert.alert_type.startsWith("correlation:");
          return (
            <article
              className={`alert-item alert-item--${alert.severity}${isCorrelated ? " alert-item--correlated" : ""}`}
              key={alert.id}
            >
              <button
                type="button"
                className="alert-item__select"
                onClick={() => vehicle && onSelect(vehicle)}
              >
                <span className="alert-item__icon">
                  {isCorrelated ? (
                    <Workflow size={16} />
                  ) : alert.alert_type.includes("fuel") ? (
                    <Fuel size={16} />
                  ) : (
                    <AlertTriangle size={16} />
                  )}
                </span>
                <span>
                  <small>
                    {vehicle?.unit_code || "SISTEMA"} · {isCorrelated ? "FUSIÓN MULTISENSOR" : "AHORA"}
                  </small>
                  <strong>{alert.title}</strong>
                  <em>{alert.description}</em>
                </span>
              </button>
              <button
                type="button"
                className="alert-item__ack"
                disabled={!canAcknowledge || pendingId === alert.id}
                onClick={() => acknowledge(alert.id)}
                title={canAcknowledge ? "Reconocer alerta" : "Tu rol no puede reconocer alertas"}
                aria-label={`Reconocer alerta: ${alert.title}`}
              >
                <Check size={13} />
                {pendingId === alert.id ? "REGISTRANDO" : "RECONOCER"}
              </button>
              <i />
            </article>
          );
        })}
        {error && <p className="alert-error">{error}</p>}
        <div className="alert-item alert-item--resolved">
          <span className="alert-item__icon"><CheckCircle2 size={16} /></span>
          <span>
            <small>TRACTO-018 · 14:32</small>
            <strong>Geocerca validada</strong>
            <em>Arribo a centro logístico</em>
          </span>
        </div>
      </div>
      <footer className="rail-footer">
        <Clock3 size={13} /> SLA promedio <b>02:41</b>
        <span /><Gauge size={13} /> {alerts.filter((alert) => alert.alert_type.startsWith("correlation:")).length} correlaciones
      </footer>
    </section>
  );
}
